import { GET_MW_ACCOUNTS } from "./actions";

export function MWAccountsReducer(state = [], action) {
  switch (action.type) {
    case `${GET_MW_ACCOUNTS}_FULFILLED`: {
      return action.payload.data;
    }
    default:
      return state;
  }
}
